import { GetMentorFormServices } from "./service";
import { toast } from "react-toastify";

import {
  // GET_A_MENTOR_FORM,
  REGISTER_MENTOR,
  VIEW_PREDEFINED_OPTIONS,
  VIEW_MENTOR_APPLICATION_DATA,
} from "../../common/constants/actionConstants";
import swal from "sweetalert";
import { isLoading } from "../../common/dependencies/action/action";
import HTMLReactParser from "html-react-parser";

// export const getMentorForms = (params) => (dispatch) => {
//   dispatch(isLoading(true));
//   return getBindMentorFormData(params).then((data) => {
//     const { mentorFormList } = data;
//     //
//     if (mentorFormList) {
//       dispatch({
//         type: GET_A_MENTOR_FORM,
//         payload: mentorFormList,
//       });
//     }
//     dispatch(isLoading(false));
//   });
// };
export const getPredefineOptionsList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindMentorFormData(params).then((data) => {
    //
    const { getPredefineOptionsList } = data;
    if (getPredefineOptionsList) {
      
      dispatch({
        type: VIEW_PREDEFINED_OPTIONS,
        payload: getPredefineOptionsList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const registerMentor = (params, email, action) => async (dispatch) => {
  //
  dispatch(isLoading(true));
  return GetMentorFormServices.registerMentor(params, email, action)
    .then((response) => {
      //
      dispatch(isLoading(false));

      if (response?.data?.success) {
        dispatch(isLoading(false));
        //  let text=  HTMLReactParser(<p>Application Submitted Successfully  <br></br> To View Your Application Status, Log In again.</p>);
        //    swal("Thank you", "Application Submitted Successfully  <br>></br> To View Your Application Status, Log In again.",
        //    "success",
        //    {closeOnClickOutside: false}
        //  );
        if (action === "VERIFIED") {
          swal("Thank you", " Your Profile Updated Successfully.", "success", {
            closeOnClickOutside: false,
          });
        } else  if (action === "REQUESTINFO") {
          swal("Thank you", " Your Application Submitted", "success", {
            closeOnClickOutside: false,
          });
        } else {
          swal(
            "Thank you",
            " Application Submitted Successfully." +
              " To View Your Application Status, Log In again.",
            "success",
            { closeOnClickOutside: false }
          );
        }
        // localStorage.removeItem("SavedLoggedInData");
        // localStorage.removeItem("loggedIn");

        // toast.success(response?.data?.data);

        return true;
      } else {
        dispatch(isLoading(false));
        window.location.href = "/";
        swal(
          "ERROR",
          "Oops, this is taking longer than expected. There seems to be a connection issue.."+
          "Your data is saved, kindly request you to Login again in a few minutes and resubmit the FORM. ",
          "error",
          { closeOnClickOutside: false }
        );
        // toast.error(response?.data?.errors[0]?.message);
        return true;
      }
    })
    .catch((error) => {
      // toast.error(INTERNAL_SERVER_ERROR);
      dispatch(isLoading(false));
      window.location.href = "/";
        swal(
          "ERROR",
          " Oops, this is taking longer than expected. There seems to be a connection issue"+
          "Your data is saved, kindly request you to Login again in a few minutes and resubmit the FORM. ",
         "error",
          { closeOnClickOutside: false }
        );
        // toast.error(response?.data?.errors[0]?.message);
        return true;
    });
};

// export const savedraftMentor = (params) => async (dispatch) => {
//   //
//   dispatch(isLoading(true));
//   return GetMentorFormServices.savedraftMentor(params)
//     .then((response) => {
//       //
//       if (response?.data?.success) {
//         dispatch(isLoading(false));
//         // toast.success("Your Application Submitted Successfully");
//         // if (action === "VERIFIED") {
//         //   swal("Thank you", " Your Profile Updated Successfully", "success", {
//         //     closeOnClickOutside: false,
//         //   });
//         // } else {
//         //   swal(
//         //     "Thank you",
//         //     " Application Submitted Successfully." +
//         //       " To View Your Application Status, Log In again.",
//         //     "success",
//         //     { closeOnClickOutside: false }
//         //   );
//         // }
//         swal(
//           "Thank you",
//           " Draft saved Successfully.",
//           // " To View Your Application Status, Log In again.",
//           // "success",
//           { closeOnClickOutside: false }
//         );
//         return true;
//       } else {
//         dispatch(isLoading(false));
//         // window.location.href = "/";
//         // toast.error(response?.data?.errors[0]?.message);
//         swal("Failed", "Please Try Again", "error", {
//           closeOnClickOutside: false,
//         });
//         return false;
//       }
//     })
//     .catch((error) => {
//       // toast.error(INTERNAL_SERVER_ERROR);
//       dispatch(isLoading(false));
//     });
// };

export const savedraftMentor = (params, buttontype,action) => async (dispatch) => {
  //
  
  if (buttontype === "savedraftbutton") {
    dispatch(isLoading(true));
  }

  return GetMentorFormServices.savedraftMentor(params)
    .then((response) => {
      //
      if (response?.data?.success) {

        dispatch(isLoading(false));
        // toast.success("Your Application Submitted Successfully");
        // if (action === "VERIFIED") {
        //   swal("Thank you", " Your Profile Updated Successfully", "success", {
        //     closeOnClickOutside: false,
        //   });
        // } else {
        //   swal(
        //     "Thank you",
        //     " Application Submitted Successfully." +
        //       " To View Your Application Status, Log In again.",
        //     "success",
        //     { closeOnClickOutside: false }
        //   );
        // }
          dispatch(isLoading(false));
        if (buttontype === "savedraftbutton") {
          dispatch(isLoading(false));
// if(action==="DRAFT"){
  swal(
    "Thank you",
    " Draft Saved Successfully. Please Complete Your Application to Submit,Login Again",
    // " To View Your Application Status, Log 8072ab again.",
    // "success",
    { closeOnClickOutside: false }
  );
// }
          
        }

        return true;
      } else {
        dispatch(isLoading(false));
        // window.location.href = "/";
        // toast.error(response?.data?.errors[0]?.message);
        if (buttontype === "savedraftbutton") {
          swal("Error", "Failed to Save Draft, Please Try Again", "error", {
            closeOnClickOutside: false,
          });
        }

        return false;
      }
    })
    .catch((error) => {
      // toast.error(INTERNAL_SERVER_ERROR);
      dispatch(isLoading(false));
    });
};
export const getViewMentorApplicationData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    //
    const { getViewMentorApplicationData } = data;
    if (getViewMentorApplicationData) {
      dispatch({
        type: VIEW_MENTOR_APPLICATION_DATA,
        payload: getViewMentorApplicationData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindData(params) {
  const getViewMentorApplicationData =
    await GetMentorFormServices.getViewMentorApplicationData(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return { getViewMentorApplicationData };
}

async function getBindMentorFormData() {
  // const mentorFormList =
    // await GetMentorFormServices.getMentorFormServices().catch((e) => {
    //   return { data: [], status: false };
    // });
  const getPredefineOptionsList =
    await GetMentorFormServices.getPredefineOptionsList().catch((e) => {
      return { data: [], status: false };
    });

  return { getPredefineOptionsList };
}